import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '../../../../public/icons/landscape/close.svg'
import _imports_1 from '../../../../public/icons/landscape/EmptyStateObjectsTab.svg'
import _imports_2 from '../../../../public/icons/landscape/EmptyStateLastRun.svg'


const _hoisted_1 = { class: "alm-right-sidebar" }
const _hoisted_2 = { class: "alm-right-sidebar-header" }
const _hoisted_3 = ["title"]
const _hoisted_4 = { class: "alm-right-sidebar-details" }
const _hoisted_5 = { class: "alm-right-sidebar-details-item" }
const _hoisted_6 = { class: "fs13" }
const _hoisted_7 = { class: "alm-right-sidebar-details-item" }
const _hoisted_8 = { class: "fs13" }
const _hoisted_9 = { class: "alm-right-sidebar-details-item" }
const _hoisted_10 = { class: "fs13" }
const _hoisted_11 = { class: "alm-right-sidebar-details-item" }
const _hoisted_12 = { class: "fs13" }
const _hoisted_13 = { class: "alm-right-sidebar-details-item" }
const _hoisted_14 = { class: "fs13" }
const _hoisted_15 = { class: "alm-right-sidebar-details-item" }
const _hoisted_16 = { class: "fs13" }
const _hoisted_17 = { class: "alm-right-sidebar-details-item" }
const _hoisted_18 = { class: "fs13" }
const _hoisted_19 = { class: "alm-right-sidebar-details-item" }
const _hoisted_20 = { class: "fs13" }
const _hoisted_21 = {
  key: 0,
  class: "calm-badge"
}
const _hoisted_22 = {
  key: 0,
  class: "alm-right-sidebar-loading"
}
const _hoisted_23 = { key: 1 }
const _hoisted_24 = {
  key: 2,
  class: "alm-right-sidebar-empty-state"
}
const _hoisted_25 = { class: "alm-right-sidebar-empty-state-text" }
const _hoisted_26 = { class: "fs13" }
const _hoisted_27 = { class: "calm-badge" }
const _hoisted_28 = {
  key: 0,
  class: "alm-right-sidebar-last-run"
}
const _hoisted_29 = { class: "alm-right-sidebar-empty-state" }
const _hoisted_30 = { class: "alm-right-sidebar-empty-state-text" }
const _hoisted_31 = {
  key: 0,
  class: "alm-right-sidebar-last-run"
}
const _hoisted_32 = { class: "alm-right-sidebar-empty-state" }
const _hoisted_33 = { class: "alm-right-sidebar-empty-state-text" }
const _hoisted_34 = { class: "alm-right-button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_tab_pane = _resolveComponent("f-tab-pane")!
  const _component_f_spin = _resolveComponent("f-spin")!
  const _component_AlmFileSelectionSection = _resolveComponent("AlmFileSelectionSection")!
  const _component_AlmTimelineWrapper = _resolveComponent("AlmTimelineWrapper")!
  const _component_f_tabs = _resolveComponent("f-tabs")!
  const _component_AlmTimelineComponent = _resolveComponent("AlmTimelineComponent")!
  const _component_f_button = _resolveComponent("f-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", {
        title: _ctx.selectedAlmChangesets[0].name
      }, _toDisplayString(_ctx.selectedAlmChangesets[0].name), 9, _hoisted_3),
      _createElementVNode("img", {
        class: "theme-svg",
        role: "button",
        tabindex: "0",
        src: _imports_0,
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
      })
    ]),
    (!_ctx.selectedAlmTargetTenant)
      ? (_openBlock(), _createBlock(_component_f_tabs, {
          key: 0,
          class: "alm-right-sidebar-tabs"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_f_tab_pane, {
              tab: _ctx.localizer.Localize('LandscapeManagement_Details'),
              key: 1
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h4", _hoisted_6, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Changeset_Description')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedAlmChangesets[0].description ? _ctx.selectedAlmChangesets[0].description : "N/a"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Changeset_CreatedAt')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedAlmChangesets[0].createdAt ? _ctx.getFormattedDate(_ctx.selectedAlmChangesets[0].createdAt) : ""), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h4", _hoisted_10, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Changeset_CreatedBy')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedAlmChangesets[0].createdBy), 1)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("h4", _hoisted_12, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Changset_LastUpdated')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedAlmChangesets[0].updatedAt ? _ctx.getFormattedDate(_ctx.selectedAlmChangesets[0].updatedAt) : ""), 1)
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("h4", _hoisted_14, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Changeset_Source')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedAlmChangesets[0].source), 1)
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("h4", _hoisted_16, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Changeset_Target')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.getTargetTenant()), 1)
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("h4", _hoisted_18, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Changeset_LastDeployed')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedAlmChangesets[0].lastDeployed ? _ctx.getFormattedDate(_ctx.selectedAlmChangesets[0].lastDeployed) : _ctx.localizer.Localize('LandscapeManagement_Never_Deployed_Text')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("h4", _hoisted_20, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Changeset_DeployedBy')), 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedAlmChangesets[0].deployedBy ? _ctx.selectedAlmChangesets[0].deployedBy : _ctx.localizer.Localize('LandscapeManagement_Never_Deployed_Text')), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["tab"])),
            (_openBlock(), _createBlock(_component_f_tab_pane, { key: 2 }, {
              tab: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Objects')), 1),
                (_ctx.selectedAlmChangesetItems)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.selectedAlmChangesetItems?.length), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_ctx.loadingChangesetItems)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                      _createVNode(_component_f_spin, { spinning: _ctx.loadingChangesetItems }, null, 8, ["spinning"])
                    ]))
                  : (_ctx.selectedAlmChangesets[0]?.count > 0 && _ctx.selectedAlmChangesetItems)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        _createVNode(_component_AlmFileSelectionSection, {
                          selectedFiles: _ctx.selectedAlmChangesetItems,
                          isReadonly: true,
                          isFilesExpanded: false
                        }, null, 8, ["selectedFiles"])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _cache[1] || (_cache[1] = _createElementVNode("img", {
                          src: _imports_1,
                          alt: "Empty state icon"
                        }, null, -1)),
                        _createElementVNode("h4", _hoisted_25, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Objects_Empty_State_Text')), 1),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Objects_Empty_State_Subtext')), 1)
                      ]))
              ]),
              _: 1
            })),
            (_openBlock(), _createBlock(_component_f_tab_pane, { key: 3 }, {
              tab: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Last_run')), 1),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.calculateLastRunTenants), 1)
              ]),
              default: _withCtx(() => [
                (_ctx.calculateLastRunTenants === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _cache[3] || (_cache[3] = _createElementVNode("img", {
                          src: _imports_2,
                          alt: "Last Run Icon"
                        }, null, -1)),
                        _createElementVNode("h4", _hoisted_30, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Last_run_Empty_State_Text')), 1)
                      ])
                    ]))
                  : (_openBlock(), _createBlock(_component_AlmTimelineWrapper, {
                      key: 1,
                      currentChangeset: _ctx.selectedAlmChangesets[0]
                    }, null, 8, ["currentChangeset"]))
              ]),
              _: 1
            }))
          ]),
          _: 1
        }))
      : (_openBlock(), _createBlock(_component_f_tabs, {
          key: 1,
          class: "alm-right-sidebar-tabs"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_component_f_tab_pane, { key: 1 }, {
              tab: _withCtx(() => [
                _createElementVNode("span", null, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Last_run')), 1)
              ]),
              default: _withCtx(() => [
                (!_ctx.selectedAlmTargetTenant?.deployedAt)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        _cache[4] || (_cache[4] = _createElementVNode("img", {
                          src: _imports_2,
                          alt: "Last Run Icon"
                        }, null, -1)),
                        _createElementVNode("h4", _hoisted_33, _toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Last_run_Empty_State_Text')), 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_AlmTimelineComponent, { currentTenant: _ctx.selectedAlmTargetTenant }, null, 8, ["currentTenant"])
              ]),
              _: 1
            }))
          ]),
          _: 1
        })),
    _createElementVNode("div", _hoisted_34, [
      _createVNode(_component_f_button, {
        type: "text",
        disabled: _ctx.selectedAlmChangesets?.[0]?.status === _ctx.STATUS.DEPLOYING,
        onClick: _ctx.handleEdit
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.localizer.Localize('Edit')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_f_button, {
        type: "primary",
        disabled: _ctx.deployButtonDisabled,
        onClick: _ctx.handleDeployment
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.localizer.Localize('LandscapeManagement_Deploy_Text')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ])
  ]))
}